import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { IS_MISSING_FILOGIX_DETAILS_DISMISSED } from "@Broker/@Modules/browser-preferences/store/browser-preferences-getters";
import { mapActions, mapGetters } from "vuex";
import { CURRENT_USER_USERNAME } from "@Broker/@Modules/main/store/account/account-getters";
import { APPLICATION_SYNC_STATUS, ARE_FILOGIX_DETAILS_VERIFIED, CURRENT_APPLICATION, IS_APPLICATION_SYNCABLE, IS_CURRENT_USER_APPLICATION_OWNER } from "../store/application-getters";
import { GET_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-getters";
import { getApplicationSyncErrorMessage } from "@Broker/js/custom/utils";
import { DISMISS_MISSING_FILOGIX_DETAILS_BANNER } from "@Broker/@Modules/browser-preferences/store/browser-preferences-actions";
import FixedBanner from "@Shared/components/general/fixed-banner.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationNotificationArea",
  components: {
    FixedBanner
  },
  props: {
    applicationId: {
      type: [String, Number],
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    },
    directToLenderTab: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("AccountStore", [CURRENT_USER_USERNAME])), mapGetters("BrowserPreferencesStore", [IS_MISSING_FILOGIX_DETAILS_DISMISSED])), mapGetters("ApplicationStore", [CURRENT_APPLICATION, IS_APPLICATION_SYNCABLE, APPLICATION_SYNC_STATUS, ARE_FILOGIX_DETAILS_VERIFIED, IS_CURRENT_USER_APPLICATION_OWNER])), mapGetters("SettingsStore", [GET_FILOGIX_DETAILS])), {}, {
    isApplicationPage() {
      const currentRouteName = this.$route.name;
      return !currentRouteName || currentRouteName === "application" || currentRouteName === "application-direct-to-lender" && this.directToLenderTab === "commissions";
    },
    showCompleteAppBanner() {
      return this.isApplicationPage && this.CURRENT_APPLICATION.applicationStatus === "completed";
    },
    syncStatus() {
      return this.APPLICATION_SYNC_STATUS(this.applicationId);
    },
    filogixDetails() {
      return this.GET_FILOGIX_DETAILS;
    },
    showMissingFilogixDetailsBanner() {
      var _this$syncStatus$deta;
      if (this.IS_MISSING_FILOGIX_DETAILS_DISMISSED({
        applicationId: this.applicationId,
        username: this.CURRENT_USER_USERNAME
      })) return false;
      const errors = ["AGENT_NOT_VERIFIED", "AGENT_MISCONFIGURED"];
      const isErrorWithFilogix = _includesInstanceProperty(errors).call(errors, ((_this$syncStatus$deta = this.syncStatus.details) == null ? void 0 : _this$syncStatus$deta.errorType) || "");
      const ownerValidation = isErrorWithFilogix && !this.filogixDetails.verified;
      return this.isApplicationOwner ? ownerValidation : isErrorWithFilogix;
    },
    errorMessagePath() {
      const basePath = getApplicationSyncErrorMessage(this.syncStatus, true);
      return this.isApplicationOwner ? `${basePath}_LINK` : basePath;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions("BrowserPreferencesStore", [DISMISS_MISSING_FILOGIX_DETAILS_BANNER])), {}, {
    dismissMissingFilogixDetailsBanner() {
      this.DISMISS_MISSING_FILOGIX_DETAILS_BANNER(this.applicationId);
    }
  })
});